export const hasMoreThanOneModalOpen = () =>
  document.querySelectorAll('[data-id=design-system-modal]').length > 1;
